import React from 'react';
import { useAIAssistant } from '../AIAssistantProvider';
import ConversationList from '../admin/ConversationList';
import EscalationPanel from '../admin/EscalationPanel';
import LiveChatPanel from '../admin/LiveChatPanel';

const Sidebar: React.FC = () => {
  const ctx = useAIAssistant();
  const { theme, canAdminSystem, sidebarView, setSidebarView, liveChats, escalations } = ctx;

  return (
    <aside className={`w-56 xl:w-64 border-r flex-col ${theme.isDark ? 'border-slate-700 bg-slate-800/50' : 'border-slate-200/60 bg-slate-50/30'}`}>

      {/* Sidebar tabs — only show if system admin */}
      {canAdminSystem && (
        <div className={`flex border-b shrink-0 ${theme.isDark ? 'border-slate-700' : 'border-slate-200/60'}`}>
          {(['conversations', 'livechat', 'escalations'] as const).map(tab => {
            const pendingLive = liveChats.filter(c => c.status === 'pending_human').length;
            const pendingEsc = escalations.filter(e => e.status === 'pending' || e.status === 'rerouted' || (!e.status && !e.resolved)).length;

            return (
              <button
                key={tab}
                onClick={() => setSidebarView(tab)}
                className={`flex-1 py-2 text-[9px] font-bold uppercase tracking-wider transition-colors relative ${
                  sidebarView === tab
                    ? theme.isDark ? 'text-blue-400' : 'text-blue-600'
                    : theme.isDark ? 'text-slate-500 hover:text-slate-300' : 'text-slate-400 hover:text-slate-600'
                }`}
              >
                <div className="flex items-center justify-center gap-1">
                  {tab === 'conversations' ? 'Chats' : tab === 'livechat' ? 'Live' : 'Alerts'}
                  {tab === 'livechat' && pendingLive > 0 && (
                    <span className="px-1 text-[7px] font-bold bg-red-500 text-white rounded-full leading-none animate-pulse">{pendingLive}</span>
                  )}
                  {tab === 'escalations' && pendingEsc > 0 && (
                    <span className="px-1 text-[7px] font-bold bg-red-500 text-white rounded-full leading-none">{pendingEsc}</span>
                  )}
                </div>
                {sidebarView === tab && (
                  <div className="absolute bottom-0 left-2 right-2 h-0.5 bg-blue-500 rounded-full" />
                )}
              </button>
            );
          })}
        </div>
      )}

      {/* Panel content */}
      {sidebarView === 'conversations' && <ConversationList />}
      {sidebarView === 'escalations' && canAdminSystem && <EscalationPanel />}
      {sidebarView === 'livechat' && canAdminSystem && (
        <div className="flex-1 flex flex-col min-h-0">
          <LiveChatPanel />
        </div>
      )}

      {/* Yiontech brand footer */}
      <div className={`px-3 py-2 shrink-0 border-t ${theme.isDark ? 'border-slate-700' : 'border-slate-200/60'}`}>
        <div className="flex items-center gap-2 px-1">
          <div className="w-5 h-5 bg-slate-800 rounded flex items-center justify-center text-white text-[8px] font-bold shrink-0">Y</div>
          <div className="min-w-0">
            <p className="text-[9px] text-slate-500 font-medium leading-none">Yiontech</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
